import { useEffect, useState, useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import Reel from "./Reel";
import useSound from "use-sound";

import { IDLE } from "./Reel";

import { addResult, getResults } from "../db";

import spinLoop from "../assets/audio/BetRivers_SlotMachine_ReelSpinLoop_20260708.mp3";
import stop1Effect from "../assets/audio/BetRivers_SlotMachine_ReelSpinSTOP_1_20260708.mp3";
import stop2Effect from "../assets/audio/BetRivers_SlotMachine_ReelSpinSTOP_2_20260708.mp3";
import stop3Effect from "../assets/audio/BetRivers_SlotMachine_ReelSpinSTOP_3_20260708.mp3";
import anticipationEffect from "../assets/audio/BetRivers_SlotMachine_Anticipation_AAA_20260708.mp3";

gsap.registerPlugin(useGSAP);

const oddslabels = [ null, "shirt", "hat", "grandprize" ];

export default function GameScreen({isIdle,isPlaying,onSpin,onSpinComplete,config}){

    const [ symb1, setSymb1 ] = useState();
    const [ symb2, setSymb2 ] = useState();
    const [ symb3, setSymb3 ] = useState();

    const [ picker, setPicker ] = useState(0);

    const [ prize1Odds, setPrize1Odds ] = useState([]);
    const [ prize2Odds, setPrize2Odds ] = useState([]);
    const [ prize3Odds, setPrize3Odds ] = useState([]);
    const [ nextResult, setNextResult ] = useState(0);

    const container = useRef();
    const tl = useRef();
    const reel1 = useRef(null);
    const reel2 = useRef(null);
    const reel3 = useRef(null);

    const [ playLoop, { stop } ] = useSound( spinLoop, {loop:true,onend: ()=>console.log('sound ended!')} );
    const [ playStop1 ] = useSound( stop1Effect );
    const [ playStop2 ] = useSound( stop2Effect );
    const [ playStop3 ] = useSound( stop3Effect );
    const [ playAnticipation ] = useSound( anticipationEffect );

    useGSAP(() => {
        // console.log('useGSAP',isIdle,isPlaying);
    // useEffect(() => {

        // let fT,sT,tT,cT;

        if (isPlaying) {
            console.log('GAME playing');
            
            // fT = setTimeout( pick, 1000, 1 );
            // sT = setTimeout( pick, 2000, 2 );
            // tT = setTimeout( pick, 3500, 3 );
            // cT = setTimeout( onSpinComplete, 4300 );

            const r = odds()
                .then( (val) => {

                    const d1 = 1.5+Math.random()*.5;
                    const d2 = .4+Math.random()*.4;
                    const d3 = val>0 
                                ? 2.3
                                : .4+Math.random()*.4;

                    tl.current = gsap
                        .timeline()
                        // .call(reel1.current?.rollback,[],1)
                        .call(spin,[1],.7)
                        .call(spin,[2],"+=.6")
                        .call(spin,[3],"+=.4")
                        .call(pick,[1],`+=${d1}`)
                        .call(pick,[2],`+=${d2}`)
                        .call(pick,[3],`+=${d3}`)
                        .call(onSpinComplete,null,"+=.7");

            } );

            // console.log('!',tl.current);
            

        } else if (isIdle) {
            console.log('GAME idle');
            setSymb1(IDLE);
            setSymb2(IDLE);
            setSymb3(IDLE);
            tl.current = gsap
                .timeline()
                .call(idleIt,[1],.2)
                .call(idleIt,[2],"+=.2")
                .call(idleIt,[3],"+=.2");
                // .repeatDelay(8 )
                // .repeat(-1);
        } else {
            console.log('GAME waiting',symb1,symb2,symb3);
            if (symb1===IDLE && symb2===IDLE && symb3===IDLE) {
                console.log('IDLE!');
                if (tl.current) tl.current.kill();
                // reset symbols to random.
                // reel1.current?.shuffle();
                // reel2.current?.shuffle();
                // reel3.current?.shuffle();

                tl.current = gsap
                    .timeline()
                    .call(resetIt,[1],.2)
                    .call(resetIt,[2],"+=.2")
                    .call(resetIt,[3],"+=.2");
            }
        }
        // return () => {
        //     clearTimeout(fT);
        //     clearTimeout(sT);
        //     clearTimeout(tT);
        //     clearTimeout(cT);
        // }

    // },[isIdle,isPlaying]);

    
    }, {scope:container,dependencies:[isIdle,isPlaying]});
    
    const rollback = () => {

    }
    const spin = (i) => {
        // console.log('spin',i);
        const s = '-';
        if (i===1) {
            playLoop();
            reel1.current?.spin();
            setSymb1(s);
            onSpin('-');
        } else if (i===2) {
            reel2.current?.spin();
            setSymb2(s);
            onSpin('--');
        } else if (i===3) {
            reel3.current?.spin();
            setSymb3(s);
            onSpin('---');
        }
    }
    const pick = (i) => {
        // console.log('pick',i,symb1,symb2,symb3,nextResult);
        if (i===1) {
            playStop1();
        } else if (i===2) {
            playStop2();
        } else if (i===3) {
            playStop3();
            stop();
        }
        setPicker(i);
    }
    useEffect( ()=>{
        if (picker>0) {
            console.log('picker',picker,symb1,symb2,symb3,nextResult);
            let s;
            if (picker===1) {
                s = reel1.current?.stop(nextResult);
                setSymb1(s);
                onSpin(s);
            } else if (picker===2) {
                s = reel2.current?.stop(nextResult);
                setSymb2(s);
                onSpin(symb1+s);

                if (nextResult===0 && symb1===s) {
                    console.log('need to delay 3rd spin!', tl.current);
                    tl.current.pause();
                    setTimeout( ()=>tl.current.resume(), 2000 );
                }

                if (symb1===s) {
                    playAnticipation();
                }
            } else if (picker===3) {
                if (nextResult===0 && symb1===symb2) {
                    s = reel3.current?.stop(-1,symb1);
                } else {
                    s = reel3.current?.stop(nextResult);
                }
                setSymb3(s);
                onSpin(symb1+symb2+s); 
                addResult(symb1+symb2+s);
            }
        }

    }, [picker] );

    const idleIt = (i) => {
        if (i===1) {
            reel1.current?.idle();
        } else if (i===2) {
            reel2.current?.idle();
        } else if (i===3) {
            reel3.current?.idle();
        }
    }
    const resetIt = (i) => {
        if (i===1) {
            reel1.current?.reset();
        } else if (i===2) {
            reel2.current?.reset();
        } else if (i===3) {
            reel3.current?.reset();
        }
    }

    const odds = async () => {
        const [ p1result, ...p1rest ] = [ ...prize1Odds ];
        const [ p2result, ...p2rest ] = [ ...prize2Odds ];
        const [ p3result, ...p3rest ] = [ ...prize3Odds ];

        resetOdds( 1, p1rest ); 
        resetOdds( 2, p2rest );
        resetOdds( 3, p3rest );

        let res;
        if (p3result) {
            res = await getResults('bbb');
            console.log('gave away',res.length,'grand prizes already');
            if (res.length<config.dailylimits.grandprize) {
                
                setNextResult( p3result );
                return p3result;
            }
        }
        if (p2result) {
            res = await getResults('hhh');
            console.log('gave away',res.length,'hats already');
            if (res.length<config.dailylimits.hat) {
                
                setNextResult( p2result );
                return p2result;
            }
        }
        if (p1result) {
            res = await getResults('vvv');
            console.log('gave away',res.length,'shirts already');
            if (res.length<config.dailylimits.shirt) {
                setNextResult( p1result );
                return p1result;
            }
        }

        setNextResult( 0 ); 
        return 0;
    }
    const resetOdds = (n,arr) => {
        let narr = arr;
        if (narr.length===0) {
            const nlen = config.odds[ oddslabels[n] ];
            narr = new Array( nlen ).fill(0);
            const winner = Math.round( Math.random()*nlen );
            narr[winner] = n;
            console.log('repopulate odds for',n,narr);
        }

        if (n===1) {
            setPrize1Odds( narr );
        } else if (n===2) {
            setPrize2Odds( narr );
        } else if (n===3) {
            setPrize3Odds( narr );
        }
    }

    const getContainerClass = () => {
        if (isIdle){
            return 'idle';
        } else if (symb1==='' || symb1==='i' || symb1==='-'){
            return '';
        } else if (symb1==='v'&&symb2==='v'&&symb3==='v') {
            return 'win1';
        } else if (symb1==='h'&&symb2==='h'&&symb3==='h') {
            return 'win2';
        } else if (symb1==='b'&&symb2==='b'&&symb3==='b') {
            return 'win3';
        } else if (symb1===symb2) {
            return 'anticipate';
        }
        return '';
    }

    return (
        <div className="centered">
            <div className={`flex ${getContainerClass()}`} ref={container}>
                <Reel pos={1} ref={reel1} />
                <Reel pos={2} ref={reel2} />
                <Reel pos={3} ref={reel3} />
            </div>
        </div>
    )
}